// Generated Stories Data for Style Pages
export interface StyleStory {
  storyId: string;
  userId: string;
  title: string;
  description: string;
  prompt: string;
  moral: string;
  narrator: string;
  narratorName: string;
  reader: string;
  styleId: string;
  styleName: string;
  storyMode: string;
  language: string;
  imageUrl: any;
  chapterIds: string;
  createdAt: string;
}

export const styleStoriesData: Record<string, StyleStory[]> = {
  '3d-cartoon': [
    {
      storyId: "bbbd95c6-3b86-43bc-9062-3abad0c6e119",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Bubblegum Dragon",
      description: "A dragon sneezes giant pink bubbles that carry villagers high into the sky.",
      prompt: "The Bubblegum Dragon – A dragon sneezes giant pink bubbles that carry villagers high into the sky.",
      moral: "Kindness",
      narrator: "walker",
      narratorName: "Ms. Walker",
      reader: "Toddler",
      styleId: "3D Cartoon",
      styleName: "3D Cartoon",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/bubblegum.jpeg'),
      chapterIds: "bbbd95c6-3b86-43bc-9062-3abad0c6e119",
      createdAt: "2025-09-24T07:01:44.032Z"
    },
    {
      storyId: "23238420-764d-4ccf-a9aa-808e050096f5",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Super Sloth Saves the Day",
      description: "The slowest superhero somehow always arrives just in time.",
      prompt: "Super Sloth Saves the Day – The slowest superhero somehow always arrives just in time.",
      moral: "Patience",
      narrator: "ballad",
      narratorName: "Lucky McGuire",
      reader: "Toddler",
      styleId: "3D Cartoon",
      styleName: "3D Cartoon",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/sloth.jpeg'),
      chapterIds: "23238420-764d-4ccf-a9aa-808e050096f5",
      createdAt: "2025-09-24T06:01:06.374Z"
    },
    {
      storyId: "a4e3f081-53dd-4bcc-9cd6-b91104d1785e",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Space Hamster Patrol",
      description: "Tiny jetpack hamsters protect planets from alien cheese thieves.",
      prompt: "Space Hamster Patrol – Tiny jetpack hamsters protect planets from alien cheese thieves.",
      moral: "Friendship",
      narrator: "anna",
      narratorName: "Princess Anna",
      reader: "Teen",
      styleId: "3D Cartoon",
      styleName: "3D Cartoon",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/hamster.jpeg'),
      chapterIds: "a4e3f081-53dd-4bcc-9cd6-b91104d1785e",
      createdAt: "2025-09-24T06:01:03.511Z"
    }
  ],
  'anime': [
    {
      storyId: "f9feef23-5a22-43b1-a5fc-e3123bbc59b7",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Scribble Hero",
      description: "A doodle leaps off a notebook page into the real world.",
      prompt: "The Scribble Hero – A doodle leaps off a notebook page into the real world.",
      moral: "Integrity",
      narrator: "shimmer",
      narratorName: "Cherry Twinkel",
      reader: "Toddler",
      styleId: "Anime",
      styleName: "Animation",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/scribblehero.jpeg'),
      chapterIds: "f9feef23-5a22-43b1-a5fc-e3123bbc59b7",
      createdAt: "2025-09-24T06:01:32.932Z"
    },
    {
      storyId: "b0cd98c2-77d0-403d-9c3e-70fdd3a36043",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Dancing Lamp Post",
      description: "A lamp post grooves through the city at night.",
      prompt: "The Dancing Lamp Post – A lamp post grooves through the city at night.",
      moral: "Respect",
      narrator: "albus",
      narratorName: "Sir Albus",
      reader: "Toddler",
      styleId: "Anime",
      styleName: "Animation",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/dancinglamp.jpeg'),
      chapterIds: "b0cd98c2-77d0-403d-9c3e-70fdd3a36043",
      createdAt: "2025-09-24T06:01:30.334Z"
    },
    {
      storyId: "11b2d0ee-5100-4a91-9f7f-42052513dded",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Time-Traveling Toast",
      description: "A slice of bread pops from a toaster into different eras.",
      prompt: "Time-Traveling Toast – A slice of bread pops from a toaster into different eras.",
      moral: "Truthfulness",
      narrator: "juggernaut",
      narratorName: "Lord Ragnar",
      reader: "Teen",
      styleId: "Anime",
      styleName: "Animation",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/timetravelingtoast.jpeg'),
      chapterIds: "11b2d0ee-5100-4a91-9f7f-42052513dded",
      createdAt: "2025-09-24T06:01:27.439Z"
    }
  ],
  'watercolor': [
    {
      storyId: "9ea32394-44c8-4abf-9946-3caf9c796f89",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Cloud Painter",
      description: "A boy climbs ladders to brush clouds into animal shapes.",
      prompt: "The Cloud Painter – A boy climbs ladders to brush clouds into animal shapes.",
      moral: "Integrity",
      narrator: "percy",
      narratorName: "Master Percy",
      reader: "Toddler",
      styleId: "Water Color",
      styleName: "Watercolor",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/cloudpainter.jpeg'),
      chapterIds: "9ea32394-44c8-4abf-9946-3caf9c796f89",
      createdAt: "2025-09-24T06:01:16.875Z"
    },
    {
      storyId: "241cdf7a-ed86-4173-ab6b-dce0d9f865cc",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Rainbow Umbrella",
      description: "An umbrella paints the sky wherever it opens.",
      prompt: "The Rainbow Umbrella – An umbrella paints the sky wherever it opens.",
      moral: "Sharing",
      narrator: "walker",
      narratorName: "Ms. Walker",
      reader: "Teen",
      styleId: "Water Color",
      styleName: "Watercolor",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/rainbowunbrella.jpeg'),
      chapterIds: "241cdf7a-ed86-4173-ab6b-dce0d9f865cc",
      createdAt: "2025-09-24T06:01:14.294Z"
    },
    {
      storyId: "7df388e1-78e6-44f4-8484-1534ee9adcb4",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Paper Boat Voyage",
      description: "A child's folded boat sails across endless watercolor seas.",
      prompt: "The Paper Boat Voyage – A child's folded boat sails across endless watercolor seas.",
      moral: "Perseverance",
      narrator: "nova",
      narratorName: "Penny Snow",
      reader: "Teen",
      styleId: "Water Color",
      styleName: "Watercolor",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/paperboat.jpeg'),
      chapterIds: "7df388e1-78e6-44f4-8484-1534ee9adcb4",
      createdAt: "2025-09-24T06:01:11.557Z"
    }
  ],
  'pixel': [
    {
      storyId: "b44cbff0-9e26-4e1a-9589-8da70bd2b75d",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Pixel Princess Quest",
      description: "A princess must leap across pixelated lava rivers to save her kingdom.",
      prompt: "Pixel Princess Quest – A princess must leap across pixelated lava rivers to save her kingdom.",
      moral: "Perseverance",
      narrator: "percy",
      narratorName: "Master Percy",
      reader: "Adult",
      styleId: "Pixel",
      styleName: "2D Game",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/pixelprincessquest.jpeg'),
      chapterIds: "b44cbff0-9e26-4e1a-9589-8da70bd2b75d",
      createdAt: "2025-09-24T07:29:52.219Z"
    },
    {
      storyId: "fdf999fe-bb16-4a19-a451-cab579005f93",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Coin Collector Cat",
      description: "A mischievous cat gathers golden coins across rooftops.",
      prompt: "Coin Collector Cat – A mischievous cat gathers golden coins across rooftops.",
      moral: "Reliability",
      narrator: "verse",
      narratorName: "Atlas",
      reader: "Teen",
      styleId: "Pixel",
      styleName: "2D Game",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/coincat.jpeg'),
      chapterIds: "fdf999fe-bb16-4a19-a451-cab579005f93",
      createdAt: "2025-09-24T07:20:14.476Z"
    },
    {
      storyId: "8efe5297-b603-456a-b858-803fe0ea7544",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Dungeon of Donuts",
      description: "A hero battles pastries to claim the Jelly-Filled Crown.",
      prompt: "The Dungeon of Donuts – A hero battles pastries to claim the Jelly-Filled Crown.",
      moral: "Example",
      narrator: "onyx",
      narratorName: "Boots",
      reader: "Adult",
      styleId: "Pixel",
      styleName: "2D Game",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/dundeondonuts.jpeg'),
      chapterIds: "8efe5297-b603-456a-b858-803fe0ea7544",
      createdAt: "2025-09-24T07:19:13.568Z"
    }
  ],
  'wool': [
    {
      storyId: "bcc9c6de-4eb9-4ee2-aff7-602a3b91ed95",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Yarn Bear's Picnic",
      description: "A soft bear invites knitted friends for a cozy outdoor feast.",
      prompt: "Yarn Bear's Picnic – A soft bear invites knitted friends for a cozy outdoor feast.",
      moral: "Friendship",
      narrator: "captain",
      narratorName: "Captain Flint",
      reader: "Teen",
      styleId: "Wool Knit",
      styleName: "Cozy Knit",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/yarnbear.jpeg'),
      chapterIds: "bcc9c6de-4eb9-4ee2-aff7-602a3b91ed95",
      createdAt: "2025-09-24T07:29:38.996Z"
    },
    {
      storyId: "ebb99b9b-19f3-4f1a-bda4-d1994585144a",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Woolly Moon",
      description: "Sheep knit a giant sweater to keep the moon warm.",
      prompt: "The Woolly Moon – Sheep knit a giant sweater to keep the moon warm.",
      moral: "Kindness",
      narrator: "anna",
      narratorName: "Princess Anna",
      reader: "Toddler",
      styleId: "Wool Knit",
      styleName: "Cozy Knit",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/woolymoon.jpeg'),
      chapterIds: "ebb99b9b-19f3-4f1a-bda4-d1994585144a",
      createdAt: "2025-09-24T07:29:32.542Z"
    },
    {
      storyId: "d91df329-44c0-4d87-9b78-b136948654bb",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Missing Sock Mystery",
      description: "Knitted detectives search for a lost sock in the laundry lands.",
      prompt: "The Missing Sock Mystery – Knitted detectives search for a lost sock in the laundry lands.",
      moral: "Mindfulness",
      narrator: "percy",
      narratorName: "Master Percy",
      reader: "Teen",
      styleId: "Wool Knit",
      styleName: "Cozy Knit",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/missingsock.jpeg'),
      chapterIds: "d91df329-44c0-4d87-9b78-b136948654bb",
      createdAt: "2025-09-24T06:55:39.815Z"
    }
  ],
  'claymation': [
    {
      storyId: "e70ea80a-13bd-49b2-95c7-5f6beba163c4",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Mud Pie Palace",
      description: "Kids accidentally build a real castle from clay pies.",
      prompt: "Mud Pie Palace – Kids accidentally build a real castle from clay pies.",
      moral: "Sharing",
      narrator: "ballad",
      narratorName: "Lucky McGuire",
      reader: "Toddler",
      styleId: "Claymation",
      styleName: "Claymation",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/mudpiepalace.jpeg'),
      chapterIds: "e70ea80a-13bd-49b2-95c7-5f6beba163c4",
      createdAt: "2025-09-24T07:29:46.124Z"
    },
    {
      storyId: "cbf66d20-d92d-447b-aa45-9c09fed4dcdb",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Clay Dog's Big Adventure",
      description: "A squishy dog reshapes himself to solve problems.",
      prompt: "Clay Dog's Big Adventure – A squishy dog reshapes himself to solve problems.",
      moral: "Perseverance",
      narrator: "nova",
      narratorName: "Penny Snow",
      reader: "Toddler",
      styleId: "Claymation",
      styleName: "Claymation",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/claydog.jpeg'),
      chapterIds: "cbf66d20-d92d-447b-aa45-9c09fed4dcdb",
      createdAt: "2025-09-24T06:55:59.373Z"
    },
    {
      storyId: "d4436a77-b39b-46f0-ab4c-21b01026e597",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Gooey Kingdom",
      description: "The land melts and reshapes whenever the sun shines.",
      prompt: "The Gooey Kingdom – The land melts and reshapes whenever the sun shines.",
      moral: "Contentment",
      narrator: "percy",
      narratorName: "Master Percy",
      reader: "Adult",
      styleId: "Claymation",
      styleName: "Claymation",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/gooykingdom.jpeg'),
      chapterIds: "d4436a77-b39b-46f0-ab4c-21b01026e597",
      createdAt: "2025-09-24T06:55:53.855Z"
    }
  ],
  'photo-realism': [
    {
      storyId: "16ed1fd4-ec00-49f2-8402-eeafd01fe9eb",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Forgotten Toy Car",
      description: "An old toy car drives itself to find its owner.",
      prompt: "The Forgotten Toy Car – An old toy car drives itself to find its owner.",
      moral: "Reliability",
      narrator: "arthur",
      narratorName: "King Arthur",
      reader: "Toddler",
      styleId: "Photo Realism",
      styleName: "Photo Realism",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/forgottontoy.jpeg'),
      chapterIds: "16ed1fd4-ec00-49f2-8402-eeafd01fe9eb",
      createdAt: "2025-09-24T06:56:11.130Z"
    },
    {
      storyId: "ae686f7d-9e9b-4613-b664-f9f7b67ff475",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Mirror Cat",
      description: "A curious cat wanders through a mirror into a new reality.",
      prompt: "The Mirror Cat – A curious cat wanders through a mirror into a new reality.",
      moral: "Fairness",
      narrator: "shimmer",
      narratorName: "Cherry Twinkel",
      reader: "Toddler",
      styleId: "Photo Realism",
      styleName: "Photo Realism",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/mirrorcat.jpeg'),
      chapterIds: "ae686f7d-9e9b-4613-b664-f9f7b67ff475",
      createdAt: "2025-09-24T06:56:08.383Z"
    },
    {
      storyId: "1806b7d7-eae1-4a08-8fc1-e2233a5b67c0",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Living Statue",
      description: "A city statue steps down to explore the streets.",
      prompt: "The Living Statue – A city statue steps down to explore the streets.",
      moral: "Forgiveness",
      narrator: "queen",
      narratorName: "Queen Bee",
      reader: "Adult",
      styleId: "Photo Realism",
      styleName: "Photo Realism",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/livingstatue.jpeg'),
      chapterIds: "1806b7d7-eae1-4a08-8fc1-e2233a5b67c0",
      createdAt: "2025-09-24T06:56:05.454Z"
    }
  ],
  'comic-book': [
    {
      storyId: "d61542b4-505f-409a-bd32-6e29aae01cb4",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Sidekick School",
      description: "Young sidekicks train to become full heroes.",
      prompt: "Sidekick School – Young sidekicks train to become full heroes.",
      moral: "Perseverance",
      narrator: "jane",
      narratorName: "Nimble",
      reader: "Toddler",
      styleId: "Comic Book",
      styleName: "Comic Book",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/sidekickschool.jpeg'),
      chapterIds: "d61542b4-505f-409a-bd32-6e29aae01cb4",
      createdAt: "2025-09-24T06:56:26.958Z"
    },
    {
      storyId: "d1151fb7-fd68-435c-8e51-b51eab7c8ebc",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Banana Bandit vs. Captain Peel",
      description: "A fruity battle for control of Fruitopolis.",
      prompt: "Banana Bandit vs. Captain Peel – A fruity battle for control of Fruitopolis.",
      moral: "Fairness",
      narrator: "juggernaut",
      narratorName: "Lord Ragnar",
      reader: "Toddler",
      styleId: "Comic Book",
      styleName: "Comic Book",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/bannanabandit.jpeg'),
      chapterIds: "d1151fb7-fd68-435c-8e51-b51eab7c8ebc",
      createdAt: "2025-09-24T06:56:24.359Z"
    },
    {
      storyId: "c259c8cb-cf43-4b52-aab3-9b17ae1536af",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Zap! the Toast Avenger",
      description: "A slice of toast gains powers after lightning strikes.",
      prompt: "Zap! the Toast Avenger – A slice of toast gains powers after lightning strikes.",
      moral: "Example",
      narrator: "nova",
      narratorName: "Penny Snow",
      reader: "Toddler",
      styleId: "Comic Book",
      styleName: "Comic Book",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/zapthetoast.jpeg'),
      chapterIds: "c259c8cb-cf43-4b52-aab3-9b17ae1536af",
      createdAt: "2025-09-24T06:56:21.634Z"
    }
  ],
  'minecraft': [
    {
      storyId: "ae144c4d-3954-4284-a08d-79a28d640b9f",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Build-a-Castle Race",
      description: "Friends race to finish the tallest castle before sunset.",
      prompt: "Build-a-Castle Race – Friends race to finish the tallest castle before sunset.",
      moral: "Friendship",
      narrator: "anna",
      narratorName: "Princess Anna",
      reader: "Teen",
      styleId: "Minecraft",
      styleName: "Blockcraft",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/buildacastle.jpeg'),
      chapterIds: "ae144c4d-3954-4284-a08d-79a28d640b9f",
      createdAt: "2025-09-24T06:56:35.338Z"
    },
    {
      storyId: "c2fe1903-e9d3-4792-9217-68732d14eb62",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Cube Dragon",
      description: "A blocky dragon guards the last crystal block in existence.",
      prompt: "The Cube Dragon – A blocky dragon guards the last crystal block in existence.",
      moral: "Respect",
      narrator: "sage",
      narratorName: "Sage",
      reader: "Adult",
      styleId: "Minecraft",
      styleName: "Blockcraft",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/cubedragon.jpeg'),
      chapterIds: "c2fe1903-e9d3-4792-9217-68732d14eb62",
      createdAt: "2025-09-24T06:56:32.620Z"
    },
    {
      storyId: "19be51b0-656d-4f12-af3d-2693a22307f4",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "The Pixel Pirate Ship",
      description: "A pirate crew sails across oceans of cubes.",
      prompt: "The Pixel Pirate Ship – A pirate crew sails across oceans of cubes.",
      moral: "Mindfulness",
      narrator: "captain",
      narratorName: "Captain Flint",
      reader: "Teen",
      styleId: "Minecraft",
      styleName: "Blockcraft",
      storyMode: "Regular",
      language: "en",
      imageUrl: require('../components/images/storythumbnails/pixelpirate.jpeg'),
      chapterIds: "19be51b0-656d-4f12-af3d-2693a22307f4",
      createdAt: "2025-09-24T07:11:35.603Z"
    }
  ],
  'ink-toon': [
    {
      storyId: "e3edb288-65f8-4ce5-8ce3-c0bafca2309b",
      userId: "d46046ba-8cb0-45be-b338-5f6f98b6a223",
      title: "Watch the Magic Unfold",
      description: "A hooded forest runner follows a blue spark through an enchanted Ink Toon world and discovers a distant dragon.",
      prompt: "Watch the Magic Unfold - A hooded forest runner chases a blue spark, discovers a distant dragon, and turns the adventure into a magical Fable book.",
      moral: "Imagination",
      narrator: "musical",
      narratorName: "Musical",
      reader: "Adult",
      styleId: "Ink Toon",
      styleName: "Ink Toon",
      storyMode: "Musical",
      language: "en",
      imageUrl: '/story-thumbnails/watchthemagicunfold.jpg',
      chapterIds: "",
      createdAt: "2026-06-01T00:00:00.000Z"
    }
  ]
};

export default styleStoriesData;
